import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private snackBar: MatSnackBar) {}

  handleError(error) {
    console.log(error);
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister();
        }
        window.location.reload();
      });
    }

    let message =
      'Uh oh, something went wrong, but were not 100% sure what it was. Please try again!';

    if (error) {
      /**
       * no need to throw dialogs for ngDebug Errors
       */
      if (error.hasOwnProperty('ngDebugContext')) {
        return true;
      }
      if (error.hasOwnProperty('rejection')) {
        message = error.rejection.message;
      } else if (error.hasOwnProperty('message')) {
        message = error.message;
      }
    }
    if (error.hasOwnProperty('url')) {
      if (error.url.includes('/login') && error.status === 403) {
        message = 'Invalid username or password';
      }
      if (error.url.includes('/makePayment') && error.status === 405) {
        message = 'Payment failed, choose a different card';
      }
      if (error.url.includes('/request-phone-verify')) {
        message =
          'We were unable to send a message to the phone number you entered.';
      }
      if (error.url.includes('/forgot-password')) {
        message =
          'We were unable to find a user matching the email you entered.';
      }
    }

    if (error && error.error && error.error.isAnchorApplicationError) {
      this.snackBar.open(
        error.error.clientResponse.name +
          ' - ' +
          error.error.clientResponse.reason,
        null,
        {
          data:
            error.error.clientResponse.name +
            ' - ' +
            error.error.clientResponse.reason,
          verticalPosition: 'top',
          duration: 5000,
          panelClass: 'error-snack-bar',
        },
      );
    } else {
      this.snackBar.open(message, null, {
        data: message,
        verticalPosition: 'top',
        duration: 5000,
        panelClass: 'error-snack-bar',
      });
    }
  }
}
